import { FundDrilldownData } from 'scenes/report/types';
import { Position } from 'shared/context/types';

export const mapFundDrilldownTable = (
  positionList: Position[]
): FundDrilldownData[] =>
  positionList.map(
    ({
      name,
      positionId,
      assetClass,
      instrumentType,
      notional,
      localCurrency,
      grossNotional,
      pv,
      componentVaR,
    }) => ({
      name,
      positionId,
      assetClass,
      instrumentType,
      notional: notional || null,
      localCurrency,
      grossNotional: grossNotional || null,
      pv: pv || null,
      componentVaR: componentVaR || null,
    })
  );
